// removed by extract-text-webpack-plugin
module.exports = {"switcher":"switcher","switcher__link":"switcher__link","switcher__link_lang":"switcher__link_lang","switcher__link_tringle":"switcher__link_tringle","active":"active","switcher__list":"switcher__list"};


//////////////////
// WEBPACK FOOTER
// ../css/components/_switcher.scss
// module id = 287
// module chunks = 0